export const HANDSON_EXCEL = 'HANDSON_EXCEL'
export const handson_excel = (data) => ({
  type: HANDSON_EXCEL,
  payload: data,
})
